import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3234233701/src/networker2024/src/components/Nosotros/Mentores/InstructorProfile.tsx");
